import React from "react";

interface IconProps {
  className?: string;
  fillColor?: string;
  width?: number;
  height?: number;
}

const ArrowDownIcon: React.FC<IconProps> = ({
  className = "size-6",
  fillColor = "#fff",
  width = 25,
  height = 25,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill={fillColor}
      viewBox="0 0 16 16"
      className={`bi bi-arrow-down-short f-iconColor ${className}`}
    >
      <path
        fillRule="evenodd"
        d="M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4"
      />
    </svg>
  );
};

export default ArrowDownIcon;
